module.exports = __webpack_public_path__ + "img/ATTACHMENT.2172cdbf.svg";